/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FailureReason } from './FailureReason';
import {
    FailureReasonFromJSON,
    FailureReasonFromJSONTyped,
    FailureReasonToJSON,
} from './FailureReason';
import type { Transcript } from './Transcript';
import {
    TranscriptFromJSON,
    TranscriptFromJSONTyped,
    TranscriptToJSON,
} from './Transcript';

/**
 * Response containing the status of a transcription job.
 * @export
 * @interface JobStatusResponse
 */
export interface JobStatusResponse {
    /**
     * Current status of the transcription job
     * @type {string}
     * @memberof JobStatusResponse
     */
    status: string;
    /**
     * 
     * @type {Transcript}
     * @memberof JobStatusResponse
     */
    transcript?: Transcript;
    /**
     * 
     * @type {FailureReason}
     * @memberof JobStatusResponse
     */
    failureReason?: FailureReason;
}

/**
 * Check if a given object implements the JobStatusResponse interface.
 */
export function instanceOfJobStatusResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function JobStatusResponseFromJSON(json: any): JobStatusResponse {
    return JobStatusResponseFromJSONTyped(json, false);
}

export function JobStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobStatusResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'transcript': !exists(json, 'transcript') ? undefined : TranscriptFromJSON(json['transcript']),
        'failureReason': !exists(json, 'failure_reason') ? undefined : FailureReasonFromJSON(json['failure_reason']),
    };
}

export function JobStatusResponseToJSON(value?: JobStatusResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'transcript': TranscriptToJSON(value.transcript),
        'failure_reason': FailureReasonToJSON(value.failureReason),
    };
}

